package com.essntl.uikit.components.radiobutton

import androidx.compose.foundation.layout.size
import androidx.compose.material3.RadioButton
import androidx.compose.material3.RadioButtonColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.spinner.EsSpinner

@Composable
fun EsRadioButton(
    selected: Boolean,
    onSelectedChange: (Boolean) -> Unit,
    colors: EsRadioButtonColors,
    enabled: Boolean = true,
    loading: Boolean = false,
    modifier: Modifier = Modifier,
) {
    if (loading)
        EsSpinner()
    else
        RadioButton(
            selected = selected,
            enabled = enabled,
            onClick = {
                onSelectedChange(!selected)
            },
            colors = RadioButtonColors(
                selectedColor = colors.selectedColor,
                unselectedColor = colors.unselectedColor,
                disabledSelectedColor = colors.disabledSelectedColor,
                disabledUnselectedColor = colors.disabledUnselectedColor,
            ),
            modifier = modifier.size(20.dp),
        )
}


class EsRadioButtonColors(
    val selectedColor: Color,
    val unselectedColor: Color,
    val disabledSelectedColor: Color,
    val disabledUnselectedColor: Color,
)